const buildAffordableUnitObject = (queryData, uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      QueryString: queryData,
      fmt: "structured"
    }
  };

  //dataObject.qdbapi.query = `{'3'.EX.'1'}`;
  
  if(queryData){
    dataObject.qdbapi.query = `{'3'.EX.'${queryData}'}`;
  }
  
  return dataObject;
};

export default buildAffordableUnitObject;
